import * as api from "../api";
import {
  FETCHPRODUCT,
  CREATEPRODUCT,
  UPDATEPRODUCT,
  DELETEPRODUCT,
  FETCH_ALLPRODUCTS,
  UPDATEPRODUCTGALLERY,
  DELETEIMAGE,
} from "../constants/actionTypes";
import { message } from "antd";

export const getProducts = (storeId) => async (dispatch) => {
  try {
    const { data } = await api.getProducts(storeId);
    dispatch({ type: FETCH_ALLPRODUCTS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getProduct = (id) => async (dispatch) => {
  try {
    const { data } = await api.getProduct(id);
    dispatch({ type: FETCHPRODUCT, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const createProduct =
  (formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.createProduct(formData);
      dispatch({ type: CREATEPRODUCT, data });
      if (data) {
        setLoadingButton(false);
        history("/products");
        message.success("Product added successfully");
      }
    } catch (error) {
      if (error) {
        console.log(error);
        setLoadingButton(false);
        message.error(error?.response?.data);
      }
    }
  };

export const updateProduct =
  (id, formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.updateProduct(id, formData);
      dispatch({ type: UPDATEPRODUCT, payload: data });
      if (data?._id) {
        setLoadingButton(false);
        history(`/product/${id}`);
        message.success("Product updated successfully");
      }
    } catch (error) {
      if (error) {
        setLoadingButton(false);
        console.log(error);
        message.error(error?.response?.data);
      }
    }
  };

export const updateProductGallery =
  (id, formData, history, setLoadingBtnGallery) => async (dispatch) => {
    try {
      const { data } = await api.updateProductGallery(id, formData);
      dispatch({ type: UPDATEPRODUCTGALLERY, payload: data });
      if (data) {
        setLoadingBtnGallery(false);
        history(`/product/${id}`);
        message.success("Gallery updated successfully!");
      }
    } catch (error) {
      if (error) {
        setLoadingBtnGallery(false);
        console.log(error);
        message.error(error?.response?.data);
      }
    }
  };

export const deleteProduct = (id, history) => async (dispatch) => {
  try {
    const response = await api.deleteProduct(id);
    dispatch({ type: DELETEPRODUCT, payload: id });
    if (response?.data?.success === true) {
      history("/products");
      message.success("Product deleted successfully");
    }
  } catch (error) {
    console.log(error);
    message.error(error?.response?.data);
  }
};

export const deleteImage = (id, imageName, history) => async (dispatch) => {
  try {
    const { data } = await api.deleteImage(id, imageName);

    dispatch({ type: DELETEIMAGE, payload: id, imageName });
    if (data) {
      history(`/product/${id}`);
      message.success("Image deleted successfully");
    }
  } catch (error) {
    console.log(error);
    message.error(error?.response?.data);
  }
};
